import { Component } from '@angular/core';

@Component({
    selector: 'lib-pulsating-dot',
    template: `
    <span class="center"></span>
    <span class="ring-1"></span>
    <span class="ring-2"></span>
    <span class="ring-3"></span>
  `,
    styleUrls: ['./pulsating-dot.component.scss'],
    standalone: false
})
export class PulsatingDotComponent{}